import alt from '../alt';
import attdAction from '../actions/attdAction';

class attdStore {
    constructor() {
        this.bindActions(attdAction);
        this.search = "";
        this.processing = false;
        this.selectedYear = new Date().getFullYear();
        this.selectedMonth = new Date().getMonth();
        this.iniLoad = false;
        this.staffAtd = {};
        this.staffsAtd = [];
        this.attendanceId = "";
        this.startWorkHr = 0;
        this.startWorkMin = 0;
        this.endWorkHr = 0;
        this.endWorkMin = 0;
        this.canSubmit = false;
    }
    onCanSubmit(data){
        this.canSubmit = data;
    }
    onAttendanceId(data) {
        this.attendanceId = data._id;
    }
    onProcessing(data) {
        this.processing = data;
    }
    onGetAllStaffAtdSuccess(data) {
        this.iniLoad = false;
        this.staffsAtd = data;
    }
    onGetStaffAtdSuccess(data) {
        this.staffAtd = data;
    }
    onSearch(data) {
        this.search = data;
    }
    onSelectedMonth(data) {
        this.selectedYear = data.selectedYear;
        this.selectedMonth = data.selectedMonth;
    }
    onCloseListShow() {

        if (this.staffsAtd) {
            for (let i = 0; i < this.staffsAtd.length; i++) {
                for (let j = 0; j < this.staffsAtd[i].attendance.length; j++) {
                    this.staffsAtd[i].attendance[j].shouldDDListShow = false;
                }
            }
        }
        if (this.staffAtd) {
            if (this.staffAtd.attendance) {
                for (let i = 0; i < this.staffAtd.attendance.length; i++) {
                    this.staffAtd.attendance[i].shouldDDListShow = false;
                }
            }
        }
    }
    onShouldListShow(data) {
        if (data.useFor == 0) {
            this.staffsAtd[data.index].shouldListShow = !this.staffsAtd[data.index].shouldListShow;
        } else {
            this.staffAtd.shouldListShow = !this.staffAtd.shouldListShow;
        }

    }
    ///to be verified
    onShouldDDListShow(data) {
        if (data.useFor == 0) {
            let len = this.staffsAtd.length;
            for (let i = 0; i < len; i++) {
                if (this.staffsAtd[i].staffId == data.staffId) {
                    this.staffsAtd[i].attendance[data.index].shouldDDListShow = !this.staffsAtd[i].attendance[data.index].shouldDDListShow;
                    break;
                }
            }
        } else {
            this.staffAtd.attendance[data.index].shouldDDListShow = !this.staffAtd.attendance[data.index].shouldDDListShow;
        }
    }
    onAttendanceCheckSuccess(data) {
        this.attendanceId = data._id;
        this.startWorkHr = data.startWorkHr;
        this.startWorkMin = data.startWorkMin;
        this.endWorkHr = data.endWorkHr;
        this.endWorkMin = data.endWorkMin;
    }
    onUpdateAttandanceSuccess(data) {
        //alllist
        let len = this.staffsAtd.length;
        let diff;
        for (let i = 0; i < len; i++) {
            if (this.staffsAtd[i].staffId == data.staffId && this.staffsAtd[i].year == data.year && this.staffsAtd[i].month == data.month) {
                this.staffsAtd[i].totalHours = data.totalHours;
                for (let j = 0; j < this.staffsAtd[i].attendance.length; j++) {
                    if (this.staffsAtd[i].attendance[j]._id == data._id) {
                        for (let k = 0; k < data.attendance.length; k++) {
                            if (this.staffsAtd[i].attendance[j]._id == data.attendance[k]._id) {
                                this.staffsAtd[i].attendance[j] = data.attendance[k];
                                break;
                            }
                        }
                        break;
                    }

                }
                break;
            }
        }
        //individual
        if (this.staffAtd.staffId == data.staffId && this.staffAtd.year == data.year && this.staffAtd.month == data.month) {
            this.staffAtd.totalHours = data.totalHours;
            for (let j = 0; j < this.staffAtd.attendance.length; j++) {
                if (this.staffAtd.attendance[j]._id == data._id) {
                    for (let k = 0; k < data.attendance.length; k++) {
                        console.log(data);
                        console.log(data.attendance[k]);
                        if (this.staffAtd.attendance[j]._id == data.attendance[k]._id) {
                            this.staffAtd.attendance[j] = data.attendance[k];
                            break;
                        }
                    }
                    break;
                }

            }
        }
    }
}
export default alt.createStore(attdStore, 'attdStore');


// WEBPACK FOOTER //
// ./app/stores/attdStore.js